import { flattenArray } from '../../../../utils/array-utils';
import { getOrderTicketsPerShowtime } from './get-order-tickets-per-showtime';
/**
 * Returns all currently selected tickets, across all showtimes.
 */
export const getOrderTickets = () => {
    const ticketsPerShowtime = getOrderTicketsPerShowtime();
    return [...ticketsPerShowtime.values()].reduce(flattenArray, []);
};
//# sourceMappingURL=get-order-tickets.js.map